module.exports = __webpack_public_path__ + "3a545cfc33470afbfceed29667329c77.png";